import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import styles from "components/upload-documents/upload-documents.scss";
import { trackPageAction } from "actions/shared/tracking-actions";
import { Button } from "components/common/button";
import { AlternativeUploadMethods } from "components/upload-documents/alternative-upload-methods";
import { PendingDocumentsList } from "components/upload-documents/pending-documents-list";
import { accountType, documentPropType } from "custom-prop-types";
import {
  dropDocumentAction,
  dropRejectedAction
} from "actions/pending-documents-actions";
import { fetchAccountDetailsAction } from "actions/account-settings-actions";
import { setFlashMessageAction } from "actions/app-actions";
import { UploadInlineTabs } from "components/upload-documents/upload-inline-tabs";

export class UploadDocumentsPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    let dropzoneRef;
    this.props.trackPage();
    return (
      <div>
        <UploadInlineTabs accountSlug={ this.props.accountSlug } currentPage="upload" />
        <Dropzone
          accept={ mimeTypes }
          activeClassName={ styles["active-dropzone"] }
          className={ styles.dropzone }
          disableClick
          maxSize={ 8388608 }
          onDrop={ (files) => { this.props.onDropDocument(this.props.accountId, files); } }
          onDropRejected={ () => { this.props.onDropRejected(); } }
          ref={ (node) => { dropzoneRef = node; } }
        >
          <div className={ styles["upload-modal"] }>
            <div className={ styles["upload-content"] } onClick={ (e) => e.stopPropagation() }>
              <h1 className={ styles["upload-title"] }>Upload Documents</h1>
              <div className={ styles["upload-button"] }>
                <p>Upload documents by dragging files anywhere on this page or select from your computer:</p>
                <span className="upload3">
                  <Button loading={ this.props.isUploadLoading } onClick={ () => { dropzoneRef.open(); } } primary>
                    Select documents to upload
                  </Button>
                </span>
              </div>
              <div>
                {renderPendingDocumentsList(this.props.pendingDocuments, this.props.selectedAccount)}
              </div>
              <div>
                <AlternativeUploadMethods
                  onSetFlashMessage={ this.props.onSetFlashMessage }
                  slug={ this.props.accountSlug }
                  submissionEmail={ this.props.submissionEmail }
                />
              </div>
            </div>
          </div>
        </Dropzone>
      </div>
    );
  }
}

const mimeTypes = `image/jpeg, image/jpg, image/gif, image/png, image/tiff, application/pdf,
  text/plain, application/msword, application/vnd.ms-excel, text/csv,
  application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
  application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.spreadsheet`;

UploadDocumentsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  accountSlug: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isUploadLoading: PropTypes.bool.isRequired,
  onDropDocument: PropTypes.func.isRequired,
  onDropRejected: PropTypes.func.isRequired,
  onSetFlashMessage: PropTypes.func.isRequired,
  pendingDocuments: PropTypes.arrayOf(documentPropType).isRequired,
  selectedAccount: accountType.isRequired,
  submissionEmail: PropTypes.string.isRequired,
  trackPage: PropTypes.func.isRequired
};

const renderPendingDocumentsList = (pendingDocuments, selectedAccount) => {
  if (pendingDocuments === null || pendingDocuments === undefined || pendingDocuments.length === 0) {
    return null;
  }
  return (
    <PendingDocumentsList
      pendingDocuments={ pendingDocuments }
      selectedAccount={ selectedAccount }
    />
  );
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  accountSlug: state.app.selectedAccount.slug,
  isUploadLoading: state.pendingDocuments.isUploadLoading,
  pendingDocuments: state.pendingDocuments.pendingDocuments,
  selectedAccount: state.app.selectedAccount,
  submissionEmail: state.pendingDocuments.submissionEmail
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchAccountDetailsAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Upload documents page")),
  onDropDocument: (accountId, files) => dispatch(dropDocumentAction(accountId, files)),
  onDropRejected: () => dispatch(dropRejectedAction()),
  onSetFlashMessage: (message) => dispatch(setFlashMessageAction(message))
});

export const UploadDocumentsContainer = connect(mapStateToProps, mapDispatchToProps)(UploadDocumentsPage);



// WEBPACK FOOTER //
// ./src/js/containers/upload-documents-container.jsx